import { ContentMaster } from './ContentMaster.model';
import { DocumentMaster } from './DocumentMaster.model';
import { LectureContentMaster } from './LectureContentMaster.model';
import { LectureMcqMaster } from './LectureMcqMaster.model';

export class LectureMaster{
    public lectureMasterId:number;
    public lectureName:String;
    public description:String;
    public name:String;
    public lectureDate:Date;
    public lectureContentVideosList:LectureContentMaster[];
    public lectureContentAssignmentsList:LectureContentMaster[];
    public lectureContentNotesList:LectureContentMaster[];
    public lectureMcqList:LectureMcqMaster[];
    public sequenceNo:number;
    public videoNames:string;
    public isInvisible:boolean = false;
    public errorMessage:string;
    public lectureThumbnail:ContentMaster;
    public lectureThumbnailId:number;
    public demoVideo:DocumentMaster;
}